import { useCallback, useRef, useState } from 'react';
import { useAuth } from 'src/hooks/use-auth';
// import { useNavigate } from "react-router-dom";
import { paths } from 'src/paths';
import { useRouter } from 'src/hooks/use-router';
import { updateLanguage } from 'src/locales/i18n';

export function usePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const auth = useAuth();
  // const navigate = useNavigate();
  const router = useRouter();

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleToggle = useCallback(() => {
    setOpen((prevState) => !prevState);
  }, []);

  const handleRole = useCallback(
    (tenant) => {
      setOpen(false);
      if (tenant) {
        const isChanged = auth.changeRole(tenant);
        if (isChanged) {
          router.push(paths.index);
          //navigate(paths.index);

          // When role change, the language will be change
          var language = 'r-highest' === tenant ? 'en' : 'vn';
          updateLanguage(language);
        }
      }
    },
    [auth, router],
  );

  return {
    anchorRef,
    handleClose,
    handleOpen,
    handleToggle,
    handleRole,
    open,
  };
}
